(function ($, Global) {
    var FormLicenceGlobaleComponent = function (model) {
		this.model = model;
	}

    FormLicenceGlobaleComponent.prototype.initEvents = function () {
		this.publishers();
	}

    FormLicenceGlobaleComponent.prototype.publishers = function () {
		var self = this;

        $(document).on('submit', '.form-licence-globale', function (e) {
			e.preventDefault();

			var $this = $(this);
			var $form = $this.closest('form');
			var data = $this.serializeJson();
            data['Indicatif'] = data['Indicatif'].trim();
            $.Topic('loader-show').publish('.page');

			self.model.post(data, $form);
		});

        $(document).on('input propertychange paste', '.form-licence-globale [name="Nom"], .form-licence-globale [name="Prenom"], .form-licence-globale [name="Email"], .form-licence-globale [name="Indicatif"], .form-licence-globale [name="NumeroTelephone"]', function (e) {
			var $this = $(this);

            if ($this.hasClass('is-invalid')) {
                $this.removeClass('is-invalid');
                $this.closest('.form-group').find('.form-text').remove();
			}
		});
	}

    Global.FormLicenceGlobaleComponent = FormLicenceGlobaleComponent;
}(jQuery, window));